<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing'; // Changed Link to navigate
  import { getApiUrl } from '../api';
  import { selectedCountry } from '../countryStore';
  import { getCurrencySymbol } from '../utils';
  import { authStore } from '../authStore'; // NEW
  import { login } from '../authService';   // NEW

  let plans = [];
  let isLoading = true;
  let error = '';
  let currencySymbol = '$';
  let currentUser = null;

  // Subscribe to auth to check login status
  authStore.subscribe(value => {
    currentUser = value.user;
  });

  $: if ($selectedCountry) {
    fetchPlans($selectedCountry);
    currencySymbol = getCurrencySymbol($selectedCountry);
  }

  async function fetchPlans(countryCode) {
    isLoading = true;
    error = '';
    try {
      const response = await fetch(getApiUrl(`/business-plans?countryCode=${countryCode}`));
      if (!response.ok) throw new Error('Could not fetch business plans.');
      
      const allPlans = await response.json();
      plans = allPlans.filter(p => !p.countryCode || p.countryCode === countryCode);
      
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }

  // --- NEW HANDLER ---
  function handleSelectPlan(planId) {
    if (!currentUser) {
        // If not logged in, trigger the login flow immediately
        // The user will return to this page after logging in
        login();
    } else {
        // If logged in, proceed to the protected payment page
        navigate(`/biz-payment/${planId}`);
    }
  }
</script>

<div class="plans-container">
  <h2>Upgrade Your Business ({$selectedCountry})</h2>
  <p class="subtitle">Get more credits to post promotions, products, and reach more customers.</p>

  {#if isLoading}
    <div class="loading">Loading plans...</div>
  {:else if error}
    <p class="error">{error}</p>
  {:else if plans.length === 0}
    <div class="empty-state">
      <p>No business plans are currently available for {$selectedCountry}.</p>
      <p>Please check back later or contact support.</p>
    </div>
  {:else}
    <div class="plans-grid">
      <!-- Use _id with fallback to index -->
      {#each plans as plan, i (plan._id || i)}
        <div class="plan-card">
          <div class="card-header">
            <h3>{plan.name}</h3>
            {#if plan.discountDesc}
              <span class="badge-discount">{plan.discountDesc}</span>
            {/if}
          </div>
          
          <div class="price-section">
            <span class="currency">{plan.currency || currencySymbol}</span>
            <span class="amount">{plan.amount}</span>
            <span class="frequency">/{plan.billingFrequency === 'Annually' ? 'year' : 'mo'}</span>
          </div>

          <ul class="features-list">
            <li>
              <strong>{plan.creditsOnPlan} Credits</strong> 
              <span class="sub-text">renewed {plan.billingFrequency === 'Annually' ? 'yearly' : 'monthly'}</span>
            </li>
            {#if plan.freeCredits > 0}
              <li>
                <strong>+{plan.freeCredits} Free Credits</strong>
                <span class="sub-text">one-time bonus</span>
              </li>
            {/if}
            {#if plan.freeMonths > 0}
              <li class="highlight-feature">
                🎉 First {plan.freeMonths} Month{plan.freeMonths > 1 ? 's' : ''} FREE
              </li>
            {/if}
            <li><span>Create Promotions</span></li>
            <li><span>Create Product Discounts</span></li>
            <li><span>Target Audience Messaging</span></li>
          </ul>

          <div class="card-footer">
            <!-- UPDATED: Button instead of Link -->
            <button class="select-btn" on:click={() => handleSelectPlan(plan._id || plan.id)}>
              Choose {plan.name}
            </button>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .plans-container {
    max-width: 1000px;
    margin: 2rem auto;
    padding: 0 1rem;
    text-align: center;
  }

  h2 { margin-bottom: 0.5rem; color: #333; }
  .subtitle { color: #666; margin-bottom: 3rem; }

  .plans-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    justify-content: center;
  }

  .plan-card {
    background: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  .plan-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    border-color: #007bff;
  }

  .card-header h3 { margin: 0 0 0.5rem 0; font-size: 1.4rem; color: #333; }
  
  .badge-discount {
    background-color: #e2f0d9;
    color: #28a745;
    font-size: 0.8rem;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 12px;
    display: inline-block;
    margin-bottom: 1rem;
  }

  .price-section {
    margin: 1.5rem 0;
    color: #333;
  }
  .currency { font-size: 1.2rem; vertical-align: top; font-weight: bold; }
  .amount { font-size: 3rem; font-weight: 800; line-height: 1; }
  .frequency { color: #666; font-size: 1rem; }

  .features-list {
    list-style: none;
    padding: 0;
    margin: 0 0 2rem 0;
    text-align: left;
    flex-grow: 1;
  }
  
  .features-list li {
    padding: 0.8rem 0;
    border-bottom: 1px solid #f1f1f1;
    color: #555;
  }
  .features-list li:last-child { border-bottom: none; }
  
  .sub-text {
      display: block;
      font-size: 0.8rem;
      color: #888;
  }
  
  .highlight-feature {
      color: #d63384 !important;
      font-weight: bold;
  }

  /* Updated Button Styles to match previous link look */
  .select-btn {
    display: block;
    width: 100%;
    padding: 1rem;
    background-color: #007bff;
    color: white;
    border: none; /* Reset button border */
    border-radius: 6px;
    font-weight: bold;
    font-size: 1.1rem;
    transition: background-color 0.2s;
    box-sizing: border-box;
    cursor: pointer; /* Ensure pointer on hover */
    font-family: inherit; /* Inherit font */
  }
  
  .select-btn:hover {
    background-color: #0056b3;
  }

  .error { color: red; }
  .loading { color: #666; font-size: 1.2rem; margin-top: 3rem; }
  .empty-state {
      background: #f8f9fa;
      padding: 3rem;
      border-radius: 8px;
      color: #666;
  }
</style>